import { Bell } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/utils';

interface NotificationEmptyStateProps {
  className?: string;
}

export const NotificationEmptyState: React.FC<NotificationEmptyStateProps> = ({
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center',
        'px-6 py-12',
        'text-center',
        className
      )}
    >
      {/* Bell Icon */}
      <div className="mb-6">
        <Bell
          className="w-24 h-24 text-magical-moonlight-d1/30"
          strokeWidth={1.5}
        />
      </div>

      {/* Heading */}
      <h3 className="text-base font-bold text-magical-moonlight-d3 mb-2">
        No new notification yet!
      </h3>

      {/* Subtitle */}
      <p className="text-sm text-magical-moonlight-d1 max-w-xs">
        Check this section for updates, alerts and general notifications.
      </p>
    </div>
  );
};
